import apiSlice from "state/api/apiSlice";
import { effectiveAtQuery, withBusinessValidity } from "utils/businessValidity";

export const contractsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getContractsByMeterId: builder.query({
      query: ({ communityId, meterId, effectiveAt }) => ({
        url:
          `/communities/${communityId}/meters/${meterId}/contracts` +
          `${effectiveAt ? `?${effectiveAtQuery(effectiveAt)}` : ""}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) =>
        result
          ? [
              { type: "Contract", id: arg.meterId },
              ...result.map((c) => ({ type: "Contract", id: c.id })),
            ]
          : [{ type: "Contract", id: arg.meterId }],
    }),
    /* POST */
    addNewContract: builder.mutation({
      query: ({ communityId, meterId, contract }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts`,
        method: "POST",
        body: withBusinessValidity(contract),
      }),
      invalidatesTags: (_, __, arg) => [
        { type: "Contract", id: arg.meterId },
        { type: "BusinessValidity", id: `contract:${arg.meterId}` },
      ],
    }),
    cloneContract: builder.mutation({
      query: ({ communityId, contractId, meterId }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts/${contractId}/clone`,
        method: "POST",
      }),
      invalidatesTags: (_, __, arg) => [
        { type: "Contract", id: arg.meterId },
        { type: "BusinessValidity", id: `contract:${arg.meterId}` },
      ],
    }),
    /* PUT */
    updateContract: builder.mutation({
      query: ({ communityId, meterId, contractId, contract }) => ({
        url: `/communities/${communityId}/meters/${meterId}/contracts/${contractId}`,
        method: "PUT",
        body: withBusinessValidity(contract),
      }),
      invalidatesTags: (_, __, arg) => [
        { type: "Contract", id: arg.meterId },
        { type: "BusinessValidity", id: `contract:${arg.meterId}` },
      ],
    }),
    /* DELETE */
    deleteContractById: builder.mutation({
      query: ({ communityId, meterId, contractId, effectiveAt, endDate }) => ({
        url:
          `/communities/${communityId}/meters/${meterId}/contracts/${contractId}?` +
          `${effectiveAtQuery(effectiveAt)}` +
          `${endDate ? `&end_date=${encodeURIComponent(endDate)}` : ""}`,
        method: "DELETE",
      }),
      invalidatesTags: (_, __, arg) => [
        { type: "Contract", id: arg.meterId },
        { type: "BusinessValidity", id: `contract:${arg.meterId}` },
      ],
    }),
  }),
});

export const {
  useGetContractsByMeterIdQuery,
  useAddNewContractMutation,
  useUpdateContractMutation,
  useDeleteContractByIdMutation,
  useCloneContractMutation,
} = contractsApiSlice;
